import { render, staticRenderFns } from "./SinglechoiceAnswer.vue?vue&type=template&id=e87a0180&"
import script from "./SinglechoiceAnswer.vue?vue&type=script&lang=ts&"
export * from "./SinglechoiceAnswer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports